import { ArtistBio } from '../../../components/ArtistBio'
import { useArtistDetails } from '../../../hooks/useArtistDetails'

/** A named collab's own bio, read straight under the act dialog's cover — nothing when it has none. */
export function CollabIntro({ artistId }: { artistId: string }) {
  const { details, loading } = useArtistDetails(artistId)
  if (!loading && !details?.shortBio && !details?.bio) return null
  return <ArtistBio details={details} loading={loading} compact />
}
